import React from 'react';
import { DndProvider } from 'react-dnd';
import { BaseSocketProvider } from '@src/core/socket';
import { OrderProvider } from '@src/features/order/provider';
import { HTML5Backend } from 'react-dnd-html5-backend';
import WeatherProvider from '@src/core/socket/weather';
import { ProvidersProps } from './types';
import { DroneProvider } from '@src/core/features';
import { UnitsProvider } from '@src/core/features/settings';
import { GlobalCameraProvider } from '@src/core/providers/global-camera-provider';

const AdminProviders: React.FC<ProvidersProps> = ({ children }) => (
  <WeatherProvider>
    <DndProvider backend={HTML5Backend}>
      <BaseSocketProvider>
        <UnitsProvider>
          <GlobalCameraProvider>
            <DroneProvider>
              <OrderProvider>
                {children}
              </OrderProvider>
            </DroneProvider>
          </GlobalCameraProvider>
        </UnitsProvider>
      </BaseSocketProvider>
    </DndProvider>
  </WeatherProvider>
);

export default AdminProviders;
